import React from 'react';

interface FileUploadProps {
  onFileSelect: (file: File) => void;
  accept: string;
  id: string;
  label: string;
}

const FileUpload: React.FC<FileUploadProps> = ({
  onFileSelect,
  accept,
  id,
  label,
}) => {
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <div className="mb-4">
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <input
        type="file"
        id={id}
        accept={accept}
        onChange={handleFileChange}
        className="mt-1 block w-full text-sm text-gray-500
                  file:mr-4 file:py-2 file:px-4
                  file:rounded-full file:border-0
                  file:text-sm file:font-semibold
                  file:bg-blue-50 file:text-blue-700
                  hover:file:bg-blue-100"
      />
    </div>
  );
};

export default FileUpload;
